import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const InfinityIcon = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.57947 8.11601C3.69329 5.96133 7.12652 5.96133 9.24033 8.11601L12 10.929L14.7597 8.11601C16.8735 5.96133 20.3067 5.96133 22.4205 8.11601C24.5265 10.2627 24.5265 13.7373 22.4205 15.884C20.3067 18.0387 16.8735 18.0387 14.7597 15.884L12 13.071L9.24033 15.884C7.12652 18.0387 3.69329 18.0387 1.57947 15.884C-0.52649 13.7373 -0.52649 10.2627 1.57947 8.11601ZM10.9494 12L8.16957 9.16647C6.64377 7.61118 4.17603 7.61118 2.65024 9.16647C1.11659 10.7298 1.11659 13.2702 2.65024 14.8335C4.17603 16.3888 6.64377 16.3888 8.16957 14.8335L10.9494 12ZM13.0506 12L15.8304 14.8335C17.3562 16.3888 19.824 16.3888 21.3498 14.8335C22.8834 13.2702 22.8834 10.7298 21.3498 9.16647C19.824 7.61118 17.3562 7.61118 15.8304 9.16647L13.0506 12Z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.57947 8.11601C3.69329 5.96133 7.12652 5.96133 9.24033 8.11601L12 10.929L14.7597 8.11601C16.8735 5.96133 20.3067 5.96133 22.4205 8.11601C24.5265 10.2627 24.5265 13.7373 22.4205 15.884C20.3067 18.0387 16.8735 18.0387 14.7597 15.884L12 13.071L9.24033 15.884C7.12652 18.0387 3.69329 18.0387 1.57947 15.884C-0.52649 13.7373 -0.52649 10.2627 1.57947 8.11601ZM10.9494 12L8.16957 9.16647C6.64377 7.61118 4.17603 7.61118 2.65024 9.16647C1.11659 10.7298 1.11659 13.2702 2.65024 14.8335C4.17603 16.3888 6.64377 16.3888 8.16957 14.8335L10.9494 12ZM13.0506 12L15.8304 14.8335C17.3562 16.3888 19.824 16.3888 21.3498 14.8335C22.8834 13.2702 22.8834 10.7298 21.3498 9.16647C19.824 7.61118 17.3562 7.61118 15.8304 9.16647L13.0506 12Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
